var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1175.63,
    height: 47.26,
    viewBox: "0 0 1175.63 47.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b2b2;\n      }\n\n      .cls-2 {\n        fill: #e5e6e8;\n      }\n\n      .cls-3 {\n        fill: #ba232e;\n      }\n\n      .cls-4 {\n        fill: #f9c22d;\n      }\n\n      .cls-5 {\n        fill: #41aa50;\n      }\n\n      .cls-6 {\n        fill: #fafafa;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "previewModal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scrn-grp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "browser"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "border-bottom",
    className: "cls-1",
    y: 45,
    width: 1175.63,
    height: 2.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-2",
    d: "M1175.63,12V45H0V12A12,12,0,0,1,12,0H1163.63A12,12,0,0,1,1175.63,12Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "minmaxclose"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 35.39,
    cy: 22.75,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 53.3,
    cy: 22.86,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 71.21,
    cy: 22.75,
    r: 5.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "fwd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 108.74,
    y: 12.32,
    width: 21.08,
    height: 21.08,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.23,22.15l4.68-4.7a1,1,0,0,1,1.43,0,1,1,0,0,1,0,1.43l-4,4,4,4a1,1,0,1,1-1.43,1.43l-4.68-4.68A1,1,0,0,1,116.23,22.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 133.08,
    y: 12.32,
    width: 21.08,
    height: 21.08,
    rx: 5.5,
    transform: "translate(287.23 45.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.67,23.58,142,28.27a1,1,0,0,1-1.43-1.43l4-4-4-4a1,1,0,0,1,0-1.43,1,1,0,0,1,1.43,0l4.68,4.69A1,1,0,0,1,146.67,23.58Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "search",
    className: "cls-6",
    x: 185.4,
    y: 12.1,
    width: 858.4,
    height: 21.3,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "downloads"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1097.08,
    y: 11.96,
    width: 21.44,
    height: 21.44,
    rx: 5.5,
    transform: "translate(2215.59 45.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1107.8,17a5.71,5.71,0,1,0,5.7,5.71A5.71,5.71,0,0,0,1107.8,17Zm3.4,6.75-3.4,3.4-3.4-3.4a.8.8,0,0,1,0-1.13.81.81,0,0,1,1.13,0l1.47,1.47v-4.9a.81.81,0,0,1,.8-.8.8.8,0,0,1,.8.8v4.91l1.47-1.47a.8.8,0,0,1,1.13,1.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1124.65,
    y: 11.96,
    width: 21.44,
    height: 21.44,
    rx: 5.5,
    transform: "translate(2270.74 45.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1131.45,22.68a2.09,2.09,0,1,1-2.08-2.08A2.08,2.08,0,0,1,1131.45,22.68Zm3.92-2.08a2.08,2.08,0,1,0,2.08,2.08A2.09,2.09,0,0,0,1135.37,20.6Zm6,0a2.08,2.08,0,1,0,2.08,2.08A2.09,2.09,0,0,0,1141.37,20.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1049.39,
    y: 11.96,
    width: 21.44,
    height: 21.44,
    rx: 5.5,
    transform: "translate(2120.21 45.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1066.15,24.83a6.44,6.44,0,1,1-4.55-7.89l.35-1.32,2.79,2.79a.09.09,0,0,1,0,.15l-3.81,1,.36-1.32a5.07,5.07,0,1,0,3.75,5.15l1.36.06A6.41,6.41,0,0,1,1066.15,24.83Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.d7019709feb64ed2d9c9195f5fbe784c.svg";
export { ForwardRef as ReactComponent };